import React from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function EmptyState({ isLoading, loadFailed }) {
  const t = useTranslation()

  if (isLoading) {
    return (
      <div className="comments-modal__state" aria-live="polite">
        <Spinner size="small" />
      </div>
    )
  }

  if (loadFailed) {
    return <div className="comments-modal__state" role="alert">{t('commentsModal.loadError')}</div>
  }

  return (
    <p className="image-gallery-modal__comments-empty cgt-body-base" role="status">
      {t('imageComments.empty')}
    </p>
  )
}

EmptyState.propTypes = {
  isLoading: bool.isRequired,
  loadFailed: bool.isRequired,
}

export default EmptyState
